import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalCellularConnectedNoInternet4Bar = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M20 18h2v-8h-2zm0 4h2v-2h-2zM2 22h16V8h4V2z" />
  </svg>
)
export default SvgSignalCellularConnectedNoInternet4Bar
